<template>
  <div class="gerenciamento-transportadora">
    <g-card class="card-gerenciamento-transportadora" :expansivel="true" :comecaFechado="false">
      <template #cabecalho>
        <div class="header-filtros">
          <div class="titulo-filtros-cabecalho"> Transportadoras </div>
          <div class="header-icons">
            <g-button class="trash-box" tipo="cinza" altura="35px" largura="45px" icone="icone_lixo.svg"
              tamanhoIcone="15px" somenteIcone @click="limpafiltro" :sombreado="false" v-tooltip="'Limpar filtro'"/>

            <g-button class="plus-button" corIcone="#FCB315" cor="#4F2C19" altura="35px" largura="45px" icone="pi pi-plus"
              tamanhoIcone="15px" somenteIcone :sombreado="false" @click="abrePopup"/>

            <g-button class="buscar-button-header-filtro" largura="150px" icone="icone_lupa.svg" negritoTexto
              tamanhoIcone="15px" tamanhoTexto="14px" altura="35px" gap="10px" @click="buscarTransportadoras"
              :sombreado="false">
              BUSCAR
            </g-button>
          </div>
        </div>
      </template>

      <g-form>
        <div class="gerenciamento-transportadora-conteudo espacamento-filtros">
          <div class="filtro-nome-transportadora">
            <div class="titulo-conteudo-filtros"> Unidade </div>
            <PDropDown class="input-label unidade" placeholder="TODAS" optionLabel="nome" optionValue="id"
              :options="EmpresaArray" v-model="objFiltro.UnidadeId">
            </PDropDown>
          </div>

          <div class="">
            <div class="titulo-conteudo-filtros"> CNPJ </div>
            <PInputText placeholder="Insira o CNPJ da Transportadora" v-mask="'##.###.###/####-##'"
              v-on:blur="verificaCPNJ" v-model="objFiltro.cnpj">
            </PInputText>
          </div>

          <div class="">
            <div class="titulo-conteudo-filtros">Nome da Transportadora</div>
            <PDropDown class="input" :options="TransportadoraArray" optionLabel="nomeTransportadora" optionValue="id"
              placeholder="Selecione a Transportadora" v-model="transportadoraSelecionada"
              emptyMessage="Pesquise a transportadora desejada" :filter="true"
              @filter="buscarNomeTransportadoras($event.value)" />
          </div>

          <div class="">
            <div class="titulo-conteudo-filtros"> Estado </div>
            <PDropDown class="estado-input input-label" placeholder="UF" optionValue="id" optionLabel="siglaEstado"
              :options="EstadoArray" v-model="objFiltro.EstadoId" :filter="true" @change="buscarcidade" />
          </div>

          <div class="">
            <div class="titulo-conteudo-filtros"> Cidade </div>
            <PDropDown class="cidade-input input-label" placeholder="Insira a cidade da Transportadora" optionValue="id"
              optionLabel="nomeCidade" :options="CidadeArray" :disabled="!objFiltro.EstadoId" v-model="objFiltro.CidadeId"
              @change="setCidade" @filter="buscarCidadeSemEstado($event.value)" />
          </div>
        </div>
      </g-form>
      <PDialog :closable="false" :style="{ width: '50%', margin: '0 5%', minWidth: '300px', maxWidth: '42em' }"
      class="gama-popup" v-model:visible="popup">

        <template #header>
          <div class="titulo-formulario"> Adicionar Nova Transportadora </div>
        </template>

        <div class="grupo-formulario espacamento-filtros">
          <div class="titulo-popup-finalizado"> Deseja criar uma nova Transportadora? </div>
        </div>

        <div class="botoes-popup button-popup">
          <div>
            <g-button tipo="cinza" negritoTexto largura="230px" altura="35px" @click="fechaPopup">
              NÃO
            </g-button>
          </div>
          <div>
            <g-button negritoTexto largura="230px" altura="35px" @click="novaTransportadora">
              SIM
            </g-button>
          </div>
        </div>
      </PDialog>
      <div class="buscar-button-filtro">
        <g-button class="buscar-button" largura="300px" icone="icone_lupa.svg" negritoTexto tamanhoIcone="15px"
          tamanhoTexto="14px" altura="35px" gap="10px" @click="buscarTransportadoras" :sombreado="false">
          BUSCAR
        </g-button>
      </div>
    </g-card>
   

    <g-card v-if="mensagemvazio" paddingDefault="1em 0 3em" :temCabecalho="false">
      <img class="icone-global-imagemfundo" src="@/assets/imgs/Ilustracao_erro.svg" />
      <div class="texto-padrao-imagemfundo">
        Verifique os filtros e clique em buscar para exibir os resultados
      </div>
    </g-card>

    <g-card v-else-if="!mensagemvazio" paddingDefault="0em 0 3em" :temCabecalho="false">
      <g-data-table Titulo="Transportadoras" :colunas="Colunas" :valores="TransportadorasInfoArray" EscondeColunaBotao>
      </g-data-table>
    </g-card>
  </div>
</template>

<script>
import GerenciamentoTransportadoras from "./GerenciamentoTransportadoras.js";
export default GerenciamentoTransportadoras;
</script>

<style>
@media (min-width:310px) {}

@media (min-width:368px) {}

@media (min-width:500px) {
  .gerenciamento-transportadora-conteudo {
    display: grid;
    grid-template-columns: repeat(3, 1fr) 0.5fr 1fr;
    grid-template-rows: 1fr;
    grid-column-gap: 20px;
    grid-row-gap: 00px;
  }
}

@media (min-width:801px) {}

@media (min-width:1025px) {}

@media (min-width:1281px) {}
</style>